/**
 * RaceTrace Live, the running order: a car's laps listed under its row when its Last or Best time
 * is tapped. From Last: its latest laps, newest first. From Best: its quickest laps, quickest
 * first. Five, or every lap.
 */
import type { CarData } from "@shared/types";

export type LapListMode = "last" | "best";

/** Laps shown before "Show all". */
export const LAP_LIST_SHORT = 5;

type Lap = CarData["laps"][number];

export function lapList(car: CarData | undefined, mode: LapListMode, all: boolean): { laps: Lap[]; total: number } {
  const timed = (car?.laps ?? []).filter((l) => l.ltSec > 0);
  const ordered = mode === "last" ? [...timed].reverse() : [...timed].sort((a, b) => a.ltSec - b.ltSec || a.l - b.l);
  return { laps: all ? ordered : ordered.slice(0, LAP_LIST_SHORT), total: ordered.length };
}
